import React, { useRef, useContext, useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Img from "gatsby-image"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { motion, useAnimation } from "framer-motion"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { useOnScreen } from "../../hooks/"
import Context from "../../context/"
import ContentWrapper from "../../styles/contentWrapper"

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';








const StyledSection = styled.section`
  width: 100%;
  height: auto;
  margin-top: 4rem;
  background: #F2F2F2;
  padding: 4rem 0;

`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    padding-right: 1rem;
    padding-left: 1rem;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }
    .section-title {
      font-style: normal;
      font-weight: 700;
      font-size: 2.4rem;
      line-height: 3rem;
      letter-spacing: -1.5px;
      color: #386097;
      margin: auto;
      span {
        color: #282A32;
      }
      text-align: center;
      margin-top: 0;
      margin-bottom: 1rem;
      padding: 0 1rem;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .section-subtitle {
      color: #4E5D6B;
      font-size: 1rem;
      line-height: 1.5rem;
      text-align: center;
      margin-top: 0;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .inner-wrapper {
      margin-top: 3rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        margin-top: 6rem;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 2rem;
      }
    }
  }
`

const StyledCard =  styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: visible!important;
  position: relative;
  box-shadow: unset!important;
  border: 1px solid #D9D9D9;
  padding: 0.7rem;
  border-radius: 1rem!important;
  margin-top: 5rem;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: unset;
    margin-top: 0;
    padding: 1.5rem;
    .card-title {
      font-size: 1.5rem;
    }
    .card-subtitle {
      font-size: 0.9rem;
    }
  }
  .MuiCardContent-root {
    background: #EDF2F7;
    width: 100%;
    border-radius: 1rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 0;
    height: 100%;
    &:last-child {
      margin-bottom: unset;
    }
    .card-title {
      color: #282A32;
      font-size: 1.2rem;
      font-weight: 700;
      line-height: 1.5rem;
      margin-bottom: 0.35em;
    }
    .card-subtitle {
      color: #4E5D6B;
      font-size: 0.8rem;
      padding: 0 1rem;
    }
  }
  .half-circle {
    width: 7rem;
    height: 3.5rem;
    border-radius: 7rem 7rem 0 0;
    background-color: white;
    position: absolute;
    top: -3.5rem;
    left: calc(50% - 3.5rem);
    border: 1px solid #D9D9D9;
    border-bottom: none;
    display: flex;
    justify-content: center;
    align-items: center;
    .gatsby-image-wrapper {
      position: unset;
    }
    img {
     width: 3.5rem;
      height: auto;
      margin: auto;
      margin-top: 1rem;
    }
  }
`


const Solutions = ({ content }) => {
  const { frontmatter, body, exports } = content[0].node
  const { items } = exports

  const { isIntroDone } = useContext(Context).state
  const tControls = useAnimation()
  const iControls = useAnimation()

  // Required for animating the text content
  const tRef = useRef()
  const tOnScreen = useOnScreen(tRef)


  // Only trigger animations if the intro is done or disabled
  useEffect(() => {
    if (isIntroDone) {
      if (tOnScreen) tControls.start({ opacity: 1, y: 0 })
    }
  }, [isIntroDone, tControls, tOnScreen])

  return (
    <StyledSection id="solutions">
      <StyledContentWrapper>
        <MDXRenderer>{body}</MDXRenderer>
        <div
          className="inner-wrapper"
          ref={tRef}
          initial={{ opacity: 0, y: 20 }}
          animate={tControls}
        >
          {items.map(({title, description, image}, k) => {
            const img = getImage(image)
            return (
              <StyledCard sx={{ minWidth: 275, height: "20rem" }}>
                <div class="half-circle">
                  <GatsbyImage image={img} alt={title} />
                </div>
    
                <CardContent>
                  <Typography className="card-title" gutterBottom>
                    {title}
                  </Typography>
                  <Typography  className="card-subtitle">
                    {description}
                  </Typography>
                </CardContent>
              </StyledCard>
            )
          })}
        </div>
      </StyledContentWrapper>
    </StyledSection>
  )
}

Solutions.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        body: PropTypes.string.isRequired,
        frontmatter: PropTypes.object.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
}

export default Solutions
